import { Routes, Route } from "react-router-dom";
import Reefer from "./Reefer";

const index = () => {
	return (
		<Routes>
			<Route path='/:id/edit' element={<Reefer />} />
		</Routes>
	);
};

export default index;
